import React from "react";
import classes from "./RegularButton.module.css";

type RegularButtonProps = {
    click?: () => void;
    disabled?: boolean;
    extraClasses?: string;
    extraStyles?: object;
};

const RegularButton: React.FC<RegularButtonProps> = (props) => {
    return (
        <button
            className={[classes.RegularButton, props.extraClasses].join(" ")}
            style={{ ...props.extraStyles }}
            disabled={props.disabled}
            onClick={props.click}>
            {props.children}
        </button>
    );
};

export default RegularButton;
